import React,{useState, useEffect} from 'react';
import {Container, Row, Col, Form, Button} from 'react-bootstrap';
import {getLugaresDataApi} from '../../../api/lugares';
import Robotin from '../../../assets/png/robo.png';
import LugaresData from '../../LugaresData';
import './Sucursales.scss';


const Sucursales = () => {
    const [lugar, setLugar] = useState(undefined);
    useEffect(() => {
        (async () =>{
          const response = await getLugaresDataApi();
          setLugar(response.lugar);
        })()
      }, []);

      
      
    const [location, setLocation] = useState("0");
    useEffect(() => { 
        setLocation({
            sucursal: lugar?.sucursal
        })
       }, [])
    return (
        <div className='container_sucursales' id='Sucursales'>
            <Container>
                <Row>
               <Col md={6} sm={12} xl={6}>
                   <div className="box">
                    <h2>Selecciona tu kids club</h2>
                      <Form.Select 
                      aria-label="Default select example"
                      onChange={e => setLocation({...location, sucursal: e.target.value})}
                      value={location.sucursal}
                      >
                      <option value="0">Selecciona una opción</option>
                {
                  lugar?.map((item) =>{
                    return(
                    <option key={item.sucursal} value={item.sucursal}>{item.sucursal}</option>
                    )
                  })
                }
                  
                   {/*    <option value="1">
                     Plaza Ojo de Agua
                     Estado de México
                     </option>
                      <option value="2">
                      Sucursal Eduardo Molina
                      CDMX
                      </option>
                      <option value="3">
                      Salón Ojo de Agua 
                      Estado de México
                      </option> */}
                      </Form.Select>    
                     <Button>
                     Seleccionar 
                     </Button>
                   </div>
               </Col> 
               <Col md={6} sm={12} xl={6} className='datos_salones'>
               {
                 (location?.sucursal === "0" || location?.sucursal === undefined) ? 
                 <img src={Robotin}></img> :
            lugar?.filter(item =>{
              if(item.sucursal === location?.sucursal  ){
                
                return item;
              
              }
              
            }).map((item =>{
              return(
                <LugaresData 
                sucursal={item.sucursal}
                direccion={item.direccion}
                horario={item.horario}
                enlace={item.lugarname}
                telefono={item.phone}
                />
            )}))
          }
                
               </Col>      
                </Row>
               
            </Container>
            <div className="color_overlay"></div>
        </div>
    );
}

export default Sucursales;
